<template>

    <div class="col">
        <p class="step-caption ft-bld">Configure your manual row</p>

        <InputWrapper placeholder="Row name" :max-chars="18" v-model="Global.newRowOverlay.name"></InputWrapper>
        <!-- <SelectOptsWrapper class="mre-z" caption="Sort" :opts="['Most viewed','Trending','Best rated']"></SelectOptsWrapper> -->
        <!-- <SliderWrapper caption="Number of content in row" :starting-num="15" :range-min="5" :range-max="45"></SliderWrapper> -->
        <SelectOptsWrapper caption="Place this row" :opts="displayAfterList" v-model="Global.newRowOverlayDisplayAfter"></SelectOptsWrapper>

        <div class="nxt-out">
            <div class="btn bck" @click.prevent="switchStep('prv')" :style="Global.rowIdToEdit ? {opacity: 0, pointerEvents: 'none'} : null">
                <span class="txt">Back</span>
            </div>
            <div class="btn main txt-blk" @click.prevent="switchStep('nxt')">
                <span class="hvr"></span>
                <span class="txt">Continue</span>
            </div>
        </div>
    </div>

</template>

<script>

    import Global from '../../lib/GlobalState'
    import InputWrapper from '../../components/InputWrapper'
    import SelectOptsWrapper from '../../components/SelectOptsWrapper'
    import SliderWrapper from '../../components/SliderWrapper'

    export default {

        name: 'NewRowTwoManual',

        components: {
            InputWrapper,
            SelectOptsWrapper,
            SliderWrapper
        },

        data() {
            return {
                Global
            }
        },

        computed: {
            displayAfterList() {

                const names = []
                names.push("In first position")

                let rows = Object.assign([], this.Global.rows)

                if(Global.rowIdToEdit) {
                    rows = rows.filter((row) => {
                        return row.id != this.Global.rowIdToEdit
                    })
                }

                rows.map((row) => {
                    names.push("After " + row.name)
                })

                return names
            }
        },

        mounted() {

            if(Global.rowIdToEdit) {
                const index = this.Global.rows.findIndex((row) => {
                    return row.id == Global.rowIdToEdit
                })

                this.Global.newRowOverlayDisplayAfter = this.displayAfterList[index]
            } else {
                this.Global.newRowOverlayDisplayAfter = this.displayAfterList[this.displayAfterList.length-1]
            }
        },

        methods: {

            switchStep(dir) {
                this.$emit(dir)
            }
        }
    }

</script>